import * as t from 'io-ts';

import {enforceType} from '../../../libs/shared/helpers/src/typescript/typeHelpers';
import {ApplicationPaginationTokenBrand} from '../../applications/bridge/v2/types/internal/paginationTypesV2';

/*
 * Parsing.
 */

interface PaginationOptions {
  offset: number;
}

export function tryParseApplicationPaginationToken(token?: string): PaginationOptions | undefined {
  if (!token) {
    return undefined;
  }

  try {
    const rawOptions = JSON.parse(atob(token));
    const {offset} = rawOptions;

    if (!Number.isInteger(offset)) {
      return undefined;
    }

    return {offset};
  } catch (error) {
    return undefined;
  }
}

/*
 * Branded type.
 */

export const RApplicationPaginationToken = t.brand(
  t.string,
  (token): token is t.Branded<string, ApplicationPaginationTokenBrand> => {
    const options = tryParseApplicationPaginationToken(token);
    return Boolean(options);
  },
  'applicationPaginationToken',
);

export function buildApplicationPaginationToken(options: PaginationOptions) {
  const token = btoa(JSON.stringify(options));
  return enforceType(RApplicationPaginationToken, token);
}
